import React from 'react';
import { useWindowDimensions } from '../../hooks/useResponsive/useResponsive';
import { IMenuBaseProps } from '../Menu/MenuBase';

export interface IDropdownBaseProps
  extends Partial<Pick<ReturnType<typeof useWindowDimensions>, 'isTablet' | 'isMobile'>>,
    Pick<IMenuBaseProps, 'debounceInMs' | 'asMenu'> {
  hovered?: boolean;
  setHovered?: (hovered?: boolean) => void;
  setPinned?: (pinned?: boolean) => void;
  expandedSectionId?: string;
  setExpandedSectionId?: (id?: string) => void;
}

export const DropdownContext = React.createContext<IDropdownBaseProps>({});
